import { CareServiceCareVolumeDto } from '@pflegix/types';
import { isWithinInterval } from 'date-fns';
import { sort } from 'radash';

/**
 * Returns the latest valid volume from the given array of volumes.
 *
 * @param volumes - An array of CareServiceCareVolumeDto objects.
 * @returns The latest valid volume, or undefined if no valid volume is found.
 */
export function getLatestValidVolume(volumes: CareServiceCareVolumeDto[]): CareServiceCareVolumeDto | undefined {
  const sortedVolumes = sort(volumes, (v) => new Date(v.validFrom).getTime(), true);

  return sortedVolumes.find((v) =>
    isWithinInterval(new Date(), {
      start: new Date(v.validFrom),
      end: new Date(v.validTo),
    })
  );
}
